export default "__VITE_ASSET___rLUA70H__"